import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export default abstract class SidePaneItem<T> {
  @Input() isEditable;
  @Input() isDisabled;
  @Input() isExpanded;
  @Input() isDashboardLocked;
  @Input() hasDataSources;
  @Input() currentDashboardPageId: number;
  @Input() dashboardPages: [];
  @Input() sentimentScale: number;
  @Output() itemAction = new EventEmitter<{ action: string; data?: any }>();

  itemType: string;

  get item(): T {
    return undefined;
  }
}
